// WhatsApp configuration and utility functions
export const WHATSAPP_NUMBER = "919825884460";

export const getWhatsAppLink = (message) => {
  const encodedMessage = encodeURIComponent(message);
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodedMessage}`;
};
